import { Badge } from '@/components/ui/badge';
import type { SimCardStatus } from '../types';

interface SimStatusBadgeProps {
  status: SimCardStatus;
  className?: string;
}

const statusConfig: Record<
  SimCardStatus,
  { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }
> = {
  active: { label: 'Active', variant: 'default' },
  inactive: { label: 'Inactive', variant: 'secondary' },
  suspended: { label: 'Suspended', variant: 'destructive' },
  inventory: { label: 'Inventory', variant: 'outline' },
  test: { label: 'Test', variant: 'outline' },
  retired: { label: 'Retired', variant: 'secondary' },
  unknown: { label: 'Unknown', variant: 'outline' },
};

export function SimStatusBadge({ status, className }: SimStatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.unknown;

  return (
    <Badge variant={config.variant} className={className}>
      {config.label}
    </Badge>
  );
}
